var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02 Buttons/04 Checkbox/btn-checked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Buttons/04-Checkbox/btn-checked",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#20C161",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: 2089713,
    transform: "translate(3.076923, 5.384615)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 5.42538967 4.74153073 10 13.8461538 1.24129423 12.5390363 4.37257068e-14 4.74153073 7.49995474 1.28901613 4.17535411"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnChecked);
export default __webpack_public_path__ + "static/media/btn-checked.11523d81a1c5fa41c067e35ce3c47b1e.svg";
export { ForwardRef as ReactComponent };